export function initYouTubeFeed(wrapper: HTMLElement) {
    if (wrapper.dataset.stgbYoutubeInit === 'true') return;

    wrapper.querySelectorAll<HTMLAnchorElement>('a[data-stgb-youtube-play]').forEach((link) => {
        const videoId = link.dataset.stgbYoutubePlay;
        if (!videoId || !/^[A-Za-z0-9_-]{11}$/.test(videoId)) return;

        link.addEventListener('click', (event) => {
            // Keep ordinary link behavior for new tabs, downloads, and other handlers.
            if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            const media = link.closest<HTMLElement>('.stgb-youtube-feed__media');
            if (!media) return;

            event.preventDefault();
            const iframe = document.createElement('iframe');
            iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
            iframe.title = link.getAttribute('aria-label') || 'YouTube video';
            iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            iframe.allowFullscreen = true;
            iframe.referrerPolicy = 'strict-origin-when-cross-origin';
            iframe.tabIndex = 0;
            media.replaceChildren(iframe);
            iframe.focus();
        });
    });

    wrapper.dataset.stgbYoutubeInit = 'true';
}

function initialize() {
    document.querySelectorAll<HTMLElement>('.stgb-youtube-feed').forEach(initYouTubeFeed);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
else initialize();
